// Zuordnung jeder Studie zu einem der 8 EAP-Themenfelder (nach Titel/Abstract).
export type StudyTopic = "resin" | "cement" | "cell" | "oaot" | "surface" | "emergence" | "allergy" | "conversion";
export const TOPIC_ORDER: StudyTopic[] = ["resin", "cement", "cell", "oaot", "surface", "emergence", "allergy", "conversion"];
export const STUDY_TOPICS: Record<number, StudyTopic> = {
"4": "resin",
"5": "resin",
"9": "resin",
"10": "resin",
"11": "resin",
"12": "resin",
"13": "resin",
"14": "resin",
"16": "resin",
"17": "resin",
"32": "cement",
"34": "cement",
"35": "cement",
"42": "surface",
"47": "cell",
"55": "surface",
"56": "surface",
"67": "surface",
"70": "cell",
"76": "oaot",
"82": "emergence",
"86": "cement",
"88": "emergence",
"100": "oaot",
"104": "oaot",
"106": "allergy",
"116": "allergy",
"123": "surface",
"125": "resin",
"126": "resin",
"129": "surface",
"130": "surface",
"131": "cement",
"132": "cement",
"133": "oaot",
"134": "surface",
"135": "conversion",
"137": "conversion",
"138": "resin",
"139": "resin",
"140": "resin",
"141": "resin",
"142": "surface",
"144": "surface",
"146": "oaot",
"147": "oaot",
"150": "cement",
"152": "resin",
"153": "surface",
"154": "emergence",
"2001": "resin",
"2002": "resin",
"2003": "resin",
"2004": "resin",
"2005": "resin",
"2006": "resin",
"2007": "resin",
"2008": "cement",
"2009": "cement",
"2010": "cement",
"2011": "cement",
"2012": "cement",
"2013": "cement",
"2014": "surface",
"2015": "surface",
"2016": "surface",
"2017": "surface",
"2018": "surface",
"2019": "cell",
"2020": "cell",
"2021": "oaot",
"2022": "oaot",
"2023": "oaot",
"2024": "oaot",
"2025": "oaot",
"2026": "surface",
"2027": "cell",
"2028": "surface",
"2029": "surface",
"2030": "cell",
"2031": "cell",
"2032": "surface",
"2033": "emergence",
"2034": "emergence",
"2035": "emergence",
"2036": "emergence",
"2037": "emergence",
"2038": "emergence",
"2039": "emergence",
"2040": "emergence",
"2041": "allergy",
"2042": "allergy",
"2043": "allergy",
"2044": "allergy",
"2045": "allergy",
"2046": "allergy",
"2047": "allergy",
"2048": "allergy",
"2049": "resin",
"2050": "conversion",
"2051": "conversion",
"2052": "conversion",
"2053": "conversion",
"3001": "resin",
"3002": "resin",
"3003": "resin",
"3004": "resin",
"3005": "resin",
"3006": "resin",
"3007": "resin",
"3008": "resin",
"3009": "cement",
"3010": "cement",
"3011": "cement",
"3012": "cement",
"3013": "cement",
"3014": "cement",
"3015": "cell",
"3016": "surface",
"3017": "cement",
"3018": "surface",
"3019": "cell",
"3020": "cell",
"3021": "oaot",
"3022": "oaot",
"3023": "oaot",
"3024": "oaot",
"3025": "oaot",
"3026": "oaot",
"3027": "oaot",
"3028": "oaot",
"3029": "oaot",
"3030": "oaot",
"3031": "oaot",
"3032": "surface",
"3033": "surface",
"3034": "surface",
"3035": "emergence",
"3036": "emergence",
"3037": "emergence",
"3038": "emergence",
"3039": "emergence",
"3040": "emergence",
"3041": "emergence",
"3042": "allergy",
"3043": "allergy",
"3044": "conversion",
"3045": "conversion",
"3046": "conversion",
"3047": "conversion",
"3048": "conversion",
"3049": "conversion",
"3050": "conversion",
"3051": "conversion",
"3052": "conversion"
};
